import { ReactElement, useCallback } from "react"

import DragDropWrapper, { useDraggableItemRefs } from "@/shared/drag-n-drop/DragDropWrapper"

import { OldBelief } from "../model/types/old-belief"

import { OldBeliefGoalCard } from "./OldBeliefGoalCard"

type Props = {
    goals: OldBelief[]
    archivedBeliefs: number[]
    onClickOldeBelief: (index: number) => void
    onArchiveCick: (index: number) => void
    onDragEnd: (result: any) => void
    dragAreaId: string
}

export const OldBeliefGoalList = ({
    goals,
    archivedBeliefs,
    onClickOldeBelief,
    onDragEnd,
    onArchiveCick,
    dragAreaId
}: Props) => {
    const isArchived = useCallback(
        id => {
            return archivedBeliefs?.includes(id)
        },
        [archivedBeliefs]
    )

    return (
        <DragDropWrapper onDrop={onDragEnd}>
            {goals.map((goal, index) => {
                const isArchivedGoal = isArchived(goal.id)

                return (
                    <CardWrapper
                        dropArea={dragAreaId}
                        key={goal.id}
                        goal={goal}
                        isArchivedGoal={isArchivedGoal}
                        index={index}
                        goalsLength={goals.length}
                        onArchiveCick={onArchiveCick}
                        onClickOldeBelief={onClickOldeBelief}
                    />
                )
            })}
        </DragDropWrapper>
    )
}

function CardWrapper({
    dropArea,
    goal,
    isArchivedGoal,
    index,
    goalsLength,
    onArchiveCick,
    onClickOldeBelief
}): ReactElement {
    const { containerRef, grabberRef }: ReturnType<typeof useDraggableItemRefs> = useDraggableItemRefs({
        index,
        id: goal.uuid,
        dropType: dropArea
    })

    return (
        <OldBeliefGoalCard
            key={goal.id}
            goal={goal}
            isArchived={isArchivedGoal}
            index={index}
            showDrag={goalsLength > 1 && !isArchivedGoal}
            onArchiveClick={onArchiveCick}
            provider={containerRef}
            snapshot={grabberRef}
            oldBeliefIndex={index}
            onClickOldeBelief={onClickOldeBelief}
        />
    )
}
